<template>
  <section class="custom-wrapper">
    <div class="row">
      <div class="col">
        <span class="custom-vehicle">{{ vehicle }}</span>
      </div>
      <div class="col">
        {{ vin }}
      </div>
      <div class="col-2">
        <span>MSRP:</span>
        <span class="custom-amount">{{ msrp }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <span>{{ trim }}</span>
      </div>
      <div class="col"></div>
      <div class="col-2">
        <span>Invoice:</span>
        <span class="custom-amount">{{ invoice }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <span>{{ driveTrain }}</span>
      </div>
      <div class="col"></div>
      <div class="col-2"></div>
      <!-- <div class="col-2">
        <span>Delivery:</span>
        <span class="custom-amount">{{ delivery }}</span>
      </div> -->
    </div>
  </section>
</template>
<script>
import { mapState } from 'pinia'
import { buildStore } from '@/stores/build'
import globals from '@/plugins/globals'
export default {
  name: 'vehicle-info',
  computed: {
    ...mapState(buildStore, ['build']),
    vin() {
      let _data = null
      if (this.build) {
        _data = this.build.vin
      }
      return _data
    },
    vehicle() {
      let _data = null
      if (this.build) {
        _data = `${this.build.year} ${this.build.make} ${this.build.model}`
      }
      return _data
    },
    trim() {
      let _data = null
      if (this.build) {
        _data = this.build.trim
        if (this.build.body_type) {
          _data += ` ${this.build.body_type}`
        }
        if (this.build.body_subtype) {
          _data += ` ${this.build.body_subtype}`
        }
        if (this.build.doors) {
          _data += ' ' + this.build.doors + ' doors'
        }
        if (this.exterior_color) {
          _data += ' ' + this.exterior_color.name
        }
      }
      return _data
    },
    paint() {
      let _data = null
      if (this.build) {
        if (this.build.exterior_color) {
          _data = this.build.exterior_color.name
        }
      }
      return _data
    },
    driveTrain() {
      let _data = null
      if (this.build) {
        _data = `${this.build.engine} ${this.build.drivetrain} ${this.build.transmission_description}`
      }
      return _data
    },
    msrp() {
      let _data = null
      if (this.build) {
        if (this.build.combined_msrp) {
          _data = `$ ${globals.formatMoney(this.build.combined_msrp)}`
        }
      }
      return _data
    },
    delivery() {
      let _data = null
      if (this.build) {
        if (this.build.delivery_charges) {
          _data = `$ ${globals.formatMoney(this.build.delivery_charges)}`
        }
      }
      return _data
    },
    invoice() {
      let _data = null
      if (this.build) {
        if (this.build.installed_equipment) {
          if (this.build.installed_equipment["STANDARD"]) {
            let found = this.build.installed_equipment["STANDARD"].find(x => x.item === 'Dealer Invoice')
            if (found) {
              let amount = parseFloat(found.value)
              _data = `$ ${globals.formatMoney(amount)}`
            }
          } else {
            let found = this.build.installed_equipment.find(x => x.item === 'Dealer Invoice')
            if (found) {
              let amount = parseFloat(found.value)
              _data = `$ ${globals.formatMoney(amount)}`
            }
          }
        }
      }
      return _data
    }
  },
  methods: {
    showPhotos() {
      this.$emit('showPhotos')
    },
    print() { }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 5px;
}

.custom-vin {
  position: absolute;
  top: 0;
  margin: 0 auto;
  width: 100%;
}

.custom-vehicle {
  font-size: 1.1em;
  font-weight: 600;
}

.custom-features {
  margin-top: 5px;
  border-top: 1px solid #dee2e6;
  padding-top: 5px;
}

.custom-amount {
  position: relative;
  float: right;
}
</style>
